import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginLoading(state) {
      state.loading = true;
      state.error = "";
      state.errorMsg = false;
    },
    apiError(state, action) {
      const errorPayload = action.payload;
      if (typeof errorPayload === "string") {
        state.error = errorPayload;
      } else if (errorPayload?.message) {
        state.error = errorPayload.message;
      } else if (errorPayload?.data) {
        state.error =
          typeof errorPayload.data === "string"
            ? errorPayload.data
            : errorPayload.data?.message || JSON.stringify(errorPayload.data);
      } else {
        state.error = "An error occurred during login";
      }
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      state.error = "";
    },
    logoutUserSuccess(state) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const {
  loginLoading,
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
} = loginSlice.actions;

export default loginSlice.reducer;
